export default (theme) => ({
  title: {
    fontSize: '22px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginBottom: 10,
  },
  data: {
    textAlign: 'right',
    width: '50%',
  },
  column: {
    width: '50%',
    fontWeight: 600
  },
  table: {
    width: '100%',
    borderSpacing: '10px'
  },
  skeletonTable: {
    padding: 10
  },
  skeletonRow: {
    marginBottom: 8
  }
});
